export default __webpack_public_path__ + "static/media/promo-banner-transparency.31cbd642.svg";